import React from 'react'
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components'

const SpinWrapper = styled(Spin)`
font-size: ${props => props.fontSize};
color: ${props => props.color}

`

const SpinerIndicator = (props) => {
    const antIcon = <LoadingOutlined style={{fontSize: 100}} spin />

    return(
        <SpinWrapper {...props} indicator={antIcon}  tip={props.text || "Verifying..."}/>
    )
}

export default SpinerIndicator